// src/api/modules/DigitalizationApi.js
import Methods from "../methods";
import {formatDate} from "../../util/date-util";

const searchDigitalizations = (context, payload) => {
  const {filters, page, size, sortBy = "registrationDate", direction = "desc"} = payload;
  const url = `api/digitalizations/search/?page=${page}&size=${size}&sortBy=${sortBy}&direction=${direction}`;
  return Methods.doPost(context, url, filters, null);
};

const exportDigitalizationsExcel = (context, filters) => {
  const url = `api/digitalizations/export-excel`;
  const newDate = formatDate(new Date());
  const fileName = `Reporte_digitalizaciones_${newDate}.xlsx`;

  return Methods.doPostDonwload(context, url, filters, fileName, null);
};

const exportDigitalizationsPdf = (context, filters) => {
  const url = `api/digitalizations/export-pdf`;
  const newDate = formatDate(new Date());
  const fileName = `Reporte_digitalizaciones_${newDate}.pdf`;

  return Methods.doPostDonwload(context, url, filters, fileName, null);
};

const loadDigitalizationListWithFilters = (context, payload) => {
  const url = `api/digitalization-filters?${payload.params}`
  return Methods.doGet(context, url, null)
}

export default {
  loadDigitalizationListWithFilters,
  searchDigitalizations,
  exportDigitalizationsExcel,
  exportDigitalizationsPdf,
}



// WEBPACK FOOTER //
// ./src/api/modules/DigitalizationApi.js